import {useEffect, useState} from 'react';

import {Delete} from '@mui/icons-material';
import {Box, Grid, Paper} from '@mui/material';
import Card from '@mui/material/Card';
import styled from 'styled-components';

import Button from '../../components/form/buttons/Button/Button';
import PageContainer from '../../components/layout/PageContainer';
import DeleteProfileModal from '../../components/profile/DeleteProfileModal/DeleteProfileModal';
import Membership from '../../components/profile/Membership';
import ProfileForm from '../../components/profile/ProfileForm';
import Spinner from '../../components/spinner/Spinner';
import PageTitle from '../../components/typography/PageTitle';
import {STRIPE_PORTAL_URLS} from '../../const';
import useFetchProductsList from '../../hooks/components/connections/useFetchProductsList';
import useAuth from '../../hooks/providers/useAuth';
import usePayment from '../../hooks/providers/usePayment';
import useProfile from '../../hooks/providers/useProfile';

const LinkToStripePortal = styled.a`
  text-decoration: none;
`;

const Profile = () => {
  const auth = useAuth();
  const profileContext = useProfile();
  const {hasAccessToPaymentRelatedFeatures} = usePayment();

  const linkToStripePortal = STRIPE_PORTAL_URLS[import.meta.env.VITE_DB_ENV];

  const [isLoading, setIsLoading] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  useFetchProductsList();

  useEffect(() => {
    (async () => {
      if (auth?.user?.tokenAad) {
        setIsLoading(true);
        await profileContext.fetchProfile();
        setIsLoading(false);
      }
    })();
  }, []);

  const deleteProfile = async () => {
    await profileContext.deleteProfile();
  };

  return (
    <PageContainer fullHeight={false}>
      <Box sx={{alignSelf: 'flex-start', mb: 5}}>
        <PageTitle>Gérer mon compte</PageTitle>
      </Box>

      {isLoading ? (
        <Grid container flex={1} justifyContent="center">
          <Card elevation={3} sx={{display: 'flex', flex: 1}}>
            <Spinner text="Chargement de votre profil" isLoading />
          </Card>
        </Grid>
      ) : (
        <Grid container columnSpacing={4}>
          {hasAccessToPaymentRelatedFeatures && (
            <Grid item xs={12} md={4} display="flex" flexDirection="column">
              <Paper elevation={3} sx={{p: 2, flex: 1}}>
                <Membership />
              </Paper>
              <Grid item>
                <LinkToStripePortal href={linkToStripePortal} target="_blank">
                  <Button sx={{display: 'flex', mt: 4, mx: 'auto'}} variant="outlined" color="primary">
                    Gérer mon abonnement
                  </Button>
                </LinkToStripePortal>
              </Grid>
            </Grid>
          )}

          <Grid
            item
            xs={12}
            md={hasAccessToPaymentRelatedFeatures ? 8 : 12}
            sx={{
              paddingTop: {
                xs: 3,
                md: 0
              }
            }}
          >
            <Grid container direction="column">
              <Paper elevation={3} sx={{p: 2}}>
                <ProfileForm />
              </Paper>
              <Grid item xs={12} md={8}>
                <Button sx={{display: 'flex', mt: 4, mx: 'auto'}} onClick={() => setIsDeleteOpen(true)} variant="outlined" color="error" startIcon={<Delete />}>
                  Supprimer mon compte
                </Button>
              </Grid>
            </Grid>
          </Grid>
          <DeleteProfileModal isOpen={isDeleteOpen} onClose={() => setIsDeleteOpen(false)} deleteProfile={deleteProfile} />
        </Grid>
      )}
    </PageContainer>
  );
};

export default Profile;
